module.exports = __webpack_public_path__ + "img/w27-b1.80acbbff.jpg";